export default "__VITE_ASSET__Bw0m$sAK__"